import { axios_institute_private } from '../../../../api/setup.intersepter';
import {
	CreateCustomRoleDTO,
	CreateLeadFormDTO,
	CreateStudentIdDTO,
	EditCustomFieldsDTO,
	EditLeadFormDTO,
	NotificationSettingsDTO,
	TaxInvoiceSettingsDTO,
	InvoiceFooter,
	PurchaseHistoryTypes,
	UpdatePaymentDataTypes,
} from './types';

export const GetNotificationSettings = (id: string) => {
	return axios_institute_private({
		method: 'GET',
		url: `institute/notificationSettings?instituteId=${id}`,
	});
};

export const UpdateNotificationSettings = (body: NotificationSettingsDTO) => {
	return axios_institute_private({
		method: 'PUT',
		url: `/institute/notificationSettings`,
		data: body,
	});
};

export const GetStudentInvoiceSettings = (id: string) => {
	return axios_institute_private({
		method: 'GET',
		url: `institute/studentTaxInvoice?instituteId=${id}`,
	});
};

export const CreateStudentInvoiceSettings = (body: TaxInvoiceSettingsDTO) => {
	return axios_institute_private({
		method: 'POST',
		url: `/institute/studentTaxInvoice`,
		data: body,
	});
};

export const UpdateStudentInvoiceSettings = (body: TaxInvoiceSettingsDTO) => {
	return axios_institute_private({
		method: 'PUT',
		url: `/institute/studentTaxInvoice`,
		data: body,
	});
};

export const UpdateInvoiceFooter = (body: InvoiceFooter) => {
	return axios_institute_private({
		method: 'PUT',
		url: `/institute/studentTaxInvoice?actionType=updateInvoiceFooter`,
		data: body,
	});
};

export const CreateCustomRole = (body: CreateCustomRoleDTO) => {
	return axios_institute_private({
		method: 'POST',
		url: `/role`,
		data: body,
	});
};

export const UpdateCustomRole = (body: CreateCustomRoleDTO) => {
	return axios_institute_private({
		method: 'PUT',
		url: `/role`,
		data: body,
	});
};

export const GetRolesByInstitute = (id: string) => {
	return axios_institute_private({
		method: 'GET',
		// url: `/role?instituteId=ALL`,
		url: `/role?instituteId=${id}&includeSystemRoles=true&includeRoleUser=true`,
	});
};

export const GetRoleDomainStructure = () => {
	return axios_institute_private({
		method: 'GET',
		url: `/roleDomain?instituteId=ALL&status=ACTIVE`,
	});
};

export const GetRoleById = (id: string) => {
	return axios_institute_private({
		method: 'GET',
		url: `role?roleId=${id}`,
	});
};

export const DeleteRole = (body: any) => {
	return axios_institute_private({
		method: 'DELETE',
		url: `/role`,
		data: body,
	});
};

export const CreateStudentId = (body: CreateStudentIdDTO) => {
	return axios_institute_private({
		method: 'POST',
		url: `/studentId`,
		data: body,
	});
};

export const UpdateStudentId = (body: CreateStudentIdDTO) => {
	return axios_institute_private({
		method: 'PUT',
		url: `/studentId`,
		data: body,
	});
};

export const GetStudentIdSettings = (id: string) => {
	return axios_institute_private({
		method: 'GET',
		url: `studentId?instituteId=${id}`,
	});
};

export const GetCustomFields = (id: string) => {
	return axios_institute_private({
		method: 'GET',
		url: `institute/customParameter?instituteId=${id}`,
	});
};

export const EditCustomFields = (body: EditCustomFieldsDTO) => {
	return axios_institute_private({
		method: 'PUT',
		url: `/institute/customParameter`,
		data: body,
	});
};

export const CreateLeadForm = (body: CreateLeadFormDTO) => {
	return axios_institute_private({
		method: 'POST',
		url: `/institute/addLeadForm`,
		data: body,
	});
};

export const EditLeadForm = (body: EditLeadFormDTO) => {
	return axios_institute_private({
		method: 'PUT',
		url: `/institute/addLeadForm`,
		data: body,
	});
};

export const GetAddLeadFormById = (id: string) => {
	return axios_institute_private({
		method: 'GET',
		url: `institute/addLeadForm?addLeadFormID=${id}`,
	});
};

export const GetAddLeadFormForInstitute = (id: string) => {
	return axios_institute_private({
		method: 'GET',
		url: `institute/addLeadForm?instituteId=${id}&status=ACTIVE`,
	});
};

export const GetAddLeadForms = (id: string) => {
	return axios_institute_private({
		method: 'GET',
		url: `institute/addLeadForm?instituteId=${id}`,
	});
};

export const GetPurchaseHistory = (body: PurchaseHistoryTypes) => {
	return axios_institute_private({
		method: 'POST',
		url: `/metaIntegration?action=paymentHistory`,
		data: body,
	});
};

export const DownloadPurchaseHistoryReport = (id: string) => {
	// here the id is institute Id we are passing
	return axios_institute_private({
		method: 'GET',
		url: `metaIntegration?instituteId=${id}&action=downloadExcel`,
	});
};

export const DownloadPurchaseHistoryInvoice = (id: string) => {
	// here the id is purchaseHistory Id we are passing
	return axios_institute_private({
		method: 'GET',
		url: `/metaIntegration?purchaseHistoryId=${id}&action=downloadInvoice`,
	});
};

export const UpdatePaymentLink = (body: UpdatePaymentDataTypes) => {
	return axios_institute_private({
		method: 'PUT',
		url: `/metaIntegration?action=updateMetaPaymentLink`,
		data: body,
	});
};
